import { type StatusColorVariant } from '../components/common/StatusPill';

/**
 * Determines the color variant for deployment status
 * Used for solutonDeployments
 */
export function getDeploymentStatusColorVariant(status: string): StatusColorVariant {
  const normalizedStatus = status.toLowerCase();
  switch (normalizedStatus) {
    case 'pending':
      return 'neutral';
    case 'creating':
    case 'updating':
    case 'deleting':
      return 'warning';
    case 'ready':
      return 'success';
    case 'errored':
      return 'error';
    case 'deleted':
      return 'dark';
    default:
      return 'neutral';
  }
}

/**
 * Determines the color variant for pipeline status
 */
export function getPipelineStatusColorVariant(status: string): StatusColorVariant {
  const normalizedStatus = status.toLowerCase();
  switch (normalizedStatus) {
    case 'success':
    case 'passed':
      return 'success';
    case 'failed':
    case 'error':
      return 'error';
    case 'running':
    case 'pending':
      return 'info';
    case 'canceled':
    case 'cancelled':
      return 'dark';
    case 'skipped':
      return 'neutral';
    default:
      return 'neutral';
  }
}
